<template>
    <svg version="1.1" class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 35 35" width="8px" height="8px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
        <path fill="currentColor" d="M33.24,3.09c-0.2-0.17-0.48-0.21-0.72-0.11L1.94,15.34C1.67,15.45,1.5,15.71,1.5,16
        c0,0.29,0.18,0.56,0.45,0.66l8.14,3.17l3.12,8.24c0.12,0.31,0.43,0.49,0.75,0.45c0.24,0.03,0.48-0.06,0.64-0.27l3.43-4.41
        l9.47,7.38c0.2,0.16,0.46,0.2,0.69,0.11c0.23-0.09,0.4-0.3,0.45-0.54l4.85-27.02C33.53,3.51,33.44,3.25,33.24,3.09z M14.6,20.43
        l-0.83,5.1l-2.26-5.98L30.65,6.14L14.6,20.43z"/>
    </svg>
</template>
